import { useQueryClient } from "@tanstack/vue-query";

import { getSystemStatus, type SystemStatus } from "../api/system";
import { appQueryClient, DEFAULT_STALE_TIME_MS } from "./client";

export const systemKeys = {
  all: ["system"] as const,
  status: () => [...systemKeys.all, "status"] as const,
};

// For code outside a component, so it reuses the login page's read.
export function readSystemStatus(): Promise<SystemStatus> {
  return appQueryClient().fetchQuery({
    queryKey: systemKeys.status(),
    queryFn: ({ signal }) => getSystemStatus({ signal }),
    staleTime: DEFAULT_STALE_TIME_MS,
  });
}

// A fresh read for a caller that has just changed what it reports.
export function useFetchSystemStatus() {
  const queryClient = useQueryClient();
  return () =>
    queryClient.fetchQuery({
      queryKey: systemKeys.status(),
      queryFn: ({ signal }) => getSystemStatus({ signal }),
      staleTime: 0,
    });
}
